export enum HistoryLogs {

/**
* Order price is updated.
*
*/
 ORDER_PRICE_UPDATED = 'order_price_updated',

 /**
  * Order status is changed.
  *
  */
 ORDER_STATUS_CHANGED = 'order_status_changed',

 /**
  * Order payment status is changed.
  *
  */
  ORDER_PAYMENT_STATUS_CHANGED = 'order_payment_status_changed',

 /**
  * Shipment document is added.
  *
  */
  DOCUMENT_SHIPMEND_ADDED = 'document_shipment_added',

 /**
  * Invoice document is added.
  *
  */
  DOCUMENT_INVOICE_ADDED = 'document_invoice_added',

 /**
  * Product is reserved.
  *
  */
  PRODUCT_RESERVED = 'product_reserved',

 /**
  * Product is deleted.
  *
  */
  PRODUCT_DELETED = 'product_deleted',

 /**
  * Product delete request.
  *
  */
  PRODUCT_DELETE_REQUEST = 'product_delete_request',

 /**
  * Product quantity is updated.
  *
  */
  PRODUCT_QUANTITY_UPDATED = 'product_quantity_updated',

 /**
  * Product quantity request.
  *
  */
  PRODUCT_QUANTITY_REQUEST = 'product_quantity_request',

 /**
  * Product delivery is updated.
  *
  */
  PRODUCT_DELIVERY_UPDATED = 'product_delivery_updated',

 /**
  * Product delivery request.
  *
  */
  PRODUCT_DELIVERY_REQUEST = 'product_delivery_request',

 /**
  * Product shipment is accepted.
  *
  */
  PRODUCT_SHIPMENT_ACCEPTED = 'product_shipment_accepted',

 /**
  * Product shipment request.
  *
  */
  PRODUCT_SHIPMENT_REQUEST = 'product_shipment_request',

}
export const HistoryLogsTranslate: Record<string, string> = {
  [HistoryLogs.ORDER_PRICE_UPDATED]: 'Сумма заказа изменена',
  [HistoryLogs.ORDER_STATUS_CHANGED]: 'Статус заказа изменен',
  [HistoryLogs.DOCUMENT_INVOICE_ADDED]: 'Прикреплен счет на оплату',
  [HistoryLogs.DOCUMENT_SHIPMEND_ADDED]: 'Прикреплен документ реализации',
  [HistoryLogs.ORDER_PAYMENT_STATUS_CHANGED]: 'Статус оплаты изменен',
  [HistoryLogs.PRODUCT_DELETED]: 'Товар удален',
  [HistoryLogs.PRODUCT_DELETE_REQUEST]: 'Отправлен запрос на удаление товаров',
  [HistoryLogs.PRODUCT_QUANTITY_UPDATED]: 'Количество товаров изменено',
  [HistoryLogs.PRODUCT_QUANTITY_REQUEST]: 'Отправлен запрос на изменение количества товаров',
  [HistoryLogs.PRODUCT_DELIVERY_UPDATED]: 'Изменен способ доставки товара',
  [HistoryLogs.PRODUCT_DELIVERY_REQUEST]: 'Отправлен запрос на изменение способа доставки товара',
  [HistoryLogs.PRODUCT_SHIPMENT_ACCEPTED]: 'Подтверждена отгрузка товара',
  [HistoryLogs.PRODUCT_SHIPMENT_REQUEST]: 'Отправлен запрос на изменение способа доставки товара',
  [HistoryLogs.PRODUCT_RESERVED]: 'На товар установлен резерв',
};
